import * as angular from 'angular';
import { Subscription } from 'rxjs';

import { ViewDataModalSelectors } from '@mode/reports/domain';
import { AppStore } from '~/types/main.types';

import { SharedChartCommandActionType } from '../../actions/chart-commands/shared.actions';
import { ModalService } from '@mode/shared/ui-angularjs';
import largeModalTemplate from './view-data-large-modal.html';

class ViewDataLightboxModalController {
  static $inject = ['$scope', 'RxStoreService', 'ModalService'];

  private modal: any;
  public isOpen: boolean;
  private container: string;
  private readOnly: boolean;

  private viewDataStateSubscription: Subscription;

  constructor(
    private $scope: angular.IScope,
    private rxStoreService: AppStore,
    private modalService: ModalService
  ) {
    this.isOpen = false;
  }

  $onInit() {
    this.viewDataStateSubscription = this.rxStoreService
      .select(ViewDataModalSelectors.selectIsOpen)
      .subscribe((isOpen) => {
        if (isOpen) {
          this.handleOpen();
        } else {
          this.handleClose();
        }
      });
  }

  $onDestroy() {
    this.viewDataStateSubscription.unsubscribe();
  }

  handleOpen() {
    if (!this.isOpen) {
      this.isOpen = true;
      this.openLightbox();
    }
  }

  handleClose() {
    this.isOpen = false;
    this.modal && this.modal.close(true);
  }

  onLightboxClose() {
    this.rxStoreService.dispatch({
      type: SharedChartCommandActionType.CloseAllModals,
    });
  }

  openLightbox() {
    const attributes = {
      onLightboxClose: this.onLightboxClose.bind(this),
      readOnly: this.readOnly,
    };
    const options = {
      template: largeModalTemplate,
      appendTo: $(this.container),
    };

    // We are using a separate modal here for explore mode.
    // Following up with view data changes outside of explore mode will be handled later
    this.modal = this.modalService.openLargeModal(attributes, options);

    // If explore mode is enabled, we want `esc` and clicking the background to just close the modal and
    // not to change route.
    this.modal.result.catch(() => this.onLightboxClose());
  }
}

const ViewDataLightboxModal: angular.IComponentOptions = {
  bindings: {
    container: '@',
    readOnly: '<',
  },

  controller: ViewDataLightboxModalController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('viewDataLightboxModal', ViewDataLightboxModal);
